// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3GEY_","info":"PatientInfo_info__2fu1E"};